import UserError from './UserError.js'

export class SubscriptionsUserError extends UserError {}
